import CalendarComponent from 'src/components/calendars';
import React, { useEffect, useState } from 'react';
import SimpleCalendar from 'src/components/calendars/SimpleCalendar';
import classNames from 'classnames';
import styles from './assets/case-calendar-screen.module.scss';
import Loader from 'src/components/Loader';
import { ICase } from 'src/types/case';
import { ISeance } from 'src/types/seance';
import { QueryParams } from 'src/types/grid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { IProvider } from '../../../../../../../../types/provider';
import EventForm from './components/EventForm';
import moment from 'moment';
import LegendComponent from 'src/components/calendars/LegendComponent';

export interface StateProps {
    inProgress: boolean;
    inProgressSeances: boolean;
    caseEnt: ICase | null;
    seances: Paginated<ISeance>;
}

export interface DispatchProps {
    getCaseData: (id: string | number) => void;
    getData: (params: QueryParams) => void;
    getCases: (params: QueryParams) => void;
    updateCaseAction: (data: AnyObject) => void;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export interface OwnProps {
    provider: Partial<IProvider> | null;
    subId: string;
    tab?: string;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const Calendar: React.FunctionComponent<Props> = (props: Props) => {
    // const myEventsList: any = [];
    const [date, setDate] = useState<Date | null>(new Date());
    const [calendar, setCalendar] = useState<boolean>(false);
    const [month, setMonth] = useState<{ monthEnd: string; monthStart: string }>({
        monthStart: moment().startOf('month').format(),
        monthEnd: moment().endOf('month').format(),
    });

    const {
        caseEnt,
        inProgress,
        inProgressSeances,
        getData,
        seances,
        provider,
        getCases,
        //  getCaseData,
    } = props;
    useEffect(() => {
        getCases({
            filters: {
                provider: provider?.id,
                calendar: 1,
                all: 1,
            },
        });
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        getData({
            page: 1,
            itemsPerPage: 1200,
            filters: {
                'provider.id': provider?.id,
                'seanceDate[after]': month.monthStart,
                'seanceDate[before]': month.monthEnd,
            },
        });

        // eslint-disable-next-line
    }, [month]);

    let start: any = undefined;
    let end: any = undefined;
    if (props?.caseEnt) {
        start = new Date(`${props?.caseEnt?.caseNumberValidityFrom}`).getTime() - 120 * 60 * 1000;
        end = new Date(`${props?.caseEnt?.caseNumberValidityTo}`).getTime();
    } else {
    }
    const onChangeDate = (date: Date | any) => {
        const endOfDat = new Date(`${date}`);

        endOfDat.setHours(12, 59, 59, 999);
        setDate(endOfDat);
    };
    const onChangeNav = (date: Date) => {
        const monthStart = moment(date).startOf('month').format('YYYY-M-D');
        const endOfDat = moment(date).startOf('month').toDate();

        endOfDat.setHours(23, 59, 59, 999);
        const monthEnd = moment(date).endOf('month').format('YYYY-M-D');
        setDate(endOfDat);
        setMonth({
            monthStart,
            monthEnd,
        });
    };

    return (
        <div className={classNames(styles.calendarWrap)}>
            <div className="">
                {inProgress || inProgressSeances ? <Loader /> : null}
                <div className={classNames(styles.calendarsTop)}>
                    <LegendComponent />
                    <div className={classNames(styles.calendarMini)}>
                        {calendar ? (
                            <SimpleCalendar
                                min={start}
                                setDate={onChangeDate}
                                containerClassName={classNames(styles.absoluteCalendar)}
                                max={end}
                                nowDate={date}
                                navigateDate={onChangeNav}
                                open={'date'}
                            />
                        ) : null}
                        <button className={`btn btn-info`} onClick={(e) => setCalendar(!calendar)} type={'button'}>
                            Navigate
                        </button>
                    </div>
                </div>
                <div className="w-100">
                    <CalendarComponent
                        caseEnt={caseEnt}
                        seances={seances}
                        change={true}
                        month={month}
                        seanceForm={EventForm}
                        nowDate={date}
                        setEvent={(data) => props.updateCaseAction({ ...data })}
                    />
                </div>
            </div>
        </div>
    );
};

export default Calendar;
